module.exports = __webpack_public_path__ + "static/media/5_r_projektor_76.25_65.37.d8743b8a.png";